import React, {Component} from 'react';

class Subscribe extends Component{

    componentDidMount() {
        
      }
      
    render(){
        return(
            
        <div className="subscribe">
                <div className="container">
                    <h3 className="title">تابع جديدنا</h3>
                    <p>ابقى على إطلاع بآخر المقالات و العروض التى نقدها... نعدك بإرسال</p>
                    <form>
                            <div className="form-group wow fadeInUp">
                                <label className="subscribe-label">البريد</label>
                                <input  className="form-control subscribe-input" type="email"/>
                            </div>
                            <div className="form-group wow fadeInUp" data-wow-delay="0.25s">
                                <label  className="subscribe-label">الجوال</label>
                                <input className="form-control subscribe-input" type="text"/>
                            </div>

                            <input className="submit-btn wow fadeInUp" data-wow-delay="0.5s" type="submit"  value="اشترك الآن"/>
                    </form>
                </div>   
        </div>
        )
    }

};
export default Subscribe;
